function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewLogo = function SvgNewLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 825 417",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,379.431,214.92)"
  }, React.createElement("path", {
    d: "M0,37.606C-3.408,34.747 -8.296,34.587 -11.938,37.142C-14.37,38.847 -17.316,39.794 -20.799,39.794C-32.377,39.794 -37.457,29.933 -37.457,18.728C-37.457,7.449 -32.228,-2.188 -21.098,-2.188C-18.258,-2.188 -15.784,-1.545 -13.649,-0.344C-9.661,1.899 -4.719,1.516 -1.213,-1.425C-5.86,-7.323 -12.713,-10.704 -21.396,-10.704C-38.577,-10.704 -48.288,2.07 -48.288,18.877C-48.288,35.76 -38.502,48.31 -21.247,48.31C-11.651,48.31 -4.61,44.288 0,37.606",
    style: {
      fill: "rgb(16,81,119)",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,736.379,278.788)"
  }, React.createElement("path", {
    d: "M0,6.95L-13.447,6.95L-13.447,-16.62L0,-16.62C5.676,-16.62 11.616,-11.277 11.616,-4.181C11.616,2.841 5.676,6.95 0,6.95M0.373,-25.21L-24.054,-25.21L-24.054,6.95L-39.217,6.95L-51.319,-25.21L-64.092,-25.21L-85.681,32.16L-74.849,32.16L-69.844,18.116L-66.782,9.6L-57.967,-15.051L-57.818,-15.051L-49.89,6.954C-55.265,6.992 -60.118,10.364 -61.827,15.467L-46.997,15.467L-40.935,32.16L-29.73,32.16L-35.984,15.541L-24.054,15.541L-24.054,32.16L-13.854,32.16C-13.629,32.16 -13.447,31.977 -13.447,31.752L-13.447,15.541L0.149,15.541C12.026,15.541 21.214,7.622 21.214,-4.405C21.214,-16.432 11.803,-25.21 0.373,-25.21",
    style: {
      fill: "rgb(16,81,119)",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,153.234,416.024)"
  }, React.createElement("path", {
    d: "M0,-58.119C-5.627,-58.119 -10.188,-53.558 -10.188,-47.931L-10.188,-22.18C-10.188,-21.586 -10.203,-21.017 -10.227,-20.464L-10.227,-18.556C-10.227,-10.395 -14.995,-3.347 -21.896,-0.043C-21.424,-0.017 -20.946,0 -20.455,0C-13.297,0 -8.098,-1.842 -4.859,-5.526C-1.62,-9.209 0,-14.864 0,-22.493L0,-58.119Z",
    style: {
      fill: "rgb(16,81,119)",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(101.463,0,0,-101.463,-0.00265417,386.223)"
  }, React.createElement("path", {
    d: "M0,0.284L0,0.283C0.012,0.102 0.078,-0.039 0.198,-0.141C0.288,-0.217 0.4,-0.265 0.533,-0.284C0.665,-0.23 0.777,-0.149 0.864,-0.044C0.923,0.028 0.969,0.11 1,0.2C0.943,0.119 0.849,0.078 0.718,0.078C0.523,0.078 0.409,0.147 0.373,0.284L0,0.284Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,379.052,214.598)"
  }, React.createElement("path", {
    d: "M0,37.568C-3.405,34.712 -8.288,34.552 -11.926,37.104C-14.356,38.809 -17.298,39.754 -20.778,39.754C-32.344,39.754 -37.419,29.903 -37.419,18.709C-37.419,7.442 -32.195,-2.185 -21.076,-2.185C-18.24,-2.185 -15.769,-1.543 -13.636,-0.343C-9.652,1.897 -4.714,1.515 -1.212,-1.423C-5.854,-7.315 -12.7,-10.693 -21.374,-10.693C-38.538,-10.693 -48.239,2.068 -48.239,18.859C-48.239,35.724 -38.464,48.261 -21.225,48.261C-11.64,48.261 -4.605,44.244 0,37.568",
    style: {
      fill: "rgb(16,81,119)",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(-200.663,0,0,200.663,824.772,74.3163)"
  }, React.createElement("path", {
    d: "M0.339,-0.3L0.71,0.071C0.788,0.148 0.898,0.178 1,0.157L0.916,0.241C0.813,0.344 0.645,0.344 0.541,0.241L0,-0.3C0.047,-0.347 0.108,-0.37 0.169,-0.37C0.231,-0.37 0.292,-0.347 0.339,-0.3Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(3.60292,2.09287,2.09287,-3.60292,602.983,90.5146)"
  }, React.createElement("path", {
    d: "M3.698,0.035C8.771,0.875 13.16,4.468 14.793,9.639L3.698,12.581C-2.777,14.297 -9.416,10.441 -11.133,3.967L3.698,0.035Z",
    style: {
      fill: "rgb(16,81,119)",
      fillRule: "nonzero"
    }
  })), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-7.78606e-06)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(16,145,209)",
      stopOpacity: 1
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(5,99,173)",
      stopOpacity: 1
    }
  })), React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.0259314)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(16,145,209)",
      stopOpacity: 1
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(5,99,173)",
      stopOpacity: 1
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNewLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-logo.9782dda2.svg";
export { ForwardRef as ReactComponent };